import { render, staticRenderFns } from "./SortDropdown.vue?vue&type=template&id=411207a8&scoped=true&"
import script from "./SortDropdown.vue?vue&type=script&lang=ts&"
export * from "./SortDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./SortDropdown.vue?vue&type=style&index=0&id=411207a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411207a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('411207a8')) {
      api.createRecord('411207a8', component.options)
    } else {
      api.reload('411207a8', component.options)
    }
    module.hot.accept("./SortDropdown.vue?vue&type=template&id=411207a8&scoped=true&", function () {
      api.rerender('411207a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/filter/SortDropdown.vue"
export default component.exports